/**
 * Org Profile React Query Hooks
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getOrgProfile,
  updateOrgProfile,
  deleteOverride,
  getOrgPositioning,
  updateOrgPositioning,
} from '../services/profile';

/** Fetch org profile data (CRA + corrections + effective) */
export const useOrgProfile = (bn) =>
  useQuery({
    queryKey: ['org-profile', bn],
    queryFn:  () => getOrgProfile(bn),
    enabled:  !!bn,
    staleTime: 60_000,
  });

/** Mutation: save one or more field corrections */
export const useUpdateOrgProfile = (bn) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (corrections) => updateOrgProfile(bn, corrections),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['org-profile', bn] }),
  });
};

/** Mutation: revert a single field to CRA data */
export const useDeleteOverride = (bn) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (fieldKey) => deleteOverride(bn, fieldKey),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['org-profile', bn] }),
  });
};

export const useOrgPositioning = (bn) =>
  useQuery({
    queryKey: ['org-positioning', bn],
    queryFn: () => getOrgPositioning(bn),
    enabled: !!bn,
    staleTime: 60_000,
  });

export const useUpdateOrgPositioning = (bn) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => updateOrgPositioning(bn, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['org-positioning', bn] }),
  });
};
